import { Stack, Typography, useTheme } from '@mui/material'

const Card = ({title, precision = null, legend, children, sx = {}}) => {
  const theme = useTheme()
  return (
    <Stack
      sx={{
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: 2,
        ...sx
      }}
      p={2}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Stack direction={'row'} gap={1} alignItems={'baseline'}>
          <Typography component={'span'} sx={{fontSize: 16, color: theme.palette.grey[600]}}>
            {title}
          </Typography>
          {
            precision && (
              <Typography component={'span'} sx={{fontSize: 12}} color={theme.palette.grey[600]}>
                ({precision})
              </Typography>
            )
          }
        </Stack>
        <Stack direction={'row'} spacing={1}>
          {legend}
        </Stack>
      </Stack>
      {children}
    </Stack>
  )
}

export default Card